import {format as _formatDate, isValid} from 'date-fns'
import {createDate, createTime, parseDate, parseTime} from './parse-time'

// https://date-fns.org/v2.29.3/docs/format
const DISPLAY_DATE_FORMAT = 'dd LLL yy'
const DISPLAY_TIME_FORMAT = 'K:mmaaa'

export function formatDate(date: Date): string {
    return _formatDate(date, DISPLAY_DATE_FORMAT)
}

function pad0(num: number, count=2) {
    return String(num).padStart(count, '0')
}

export function formatIsoDate(date: Date): string {
    return `${date.getFullYear()}-${pad0(date.getMonth()+1)}-${pad0(date.getDate())}`
}

export function formatDateTime(date: Date): string {
    return _formatDate(date, DISPLAY_DATE_FORMAT + ' @ ' + DISPLAY_TIME_FORMAT)
}


export function formatTime(date: Date): string {
    return _formatDate(date, DISPLAY_TIME_FORMAT)
}

/**
 * Reformats an ISO date string (YYYY-MM-DD) to a Kymark date.
 */
export function reformatDate(dateString: string | nil, format = DISPLAY_DATE_FORMAT): string {
    if(!dateString?.length) return ''
    const dateTuple = parseDate(dateString)
    if(!dateTuple || dateTuple.some(v => v == null)) return ''
    const dateObj = createDate(...dateTuple)
    if(!isValid(dateObj)) return ''
    return _formatDate(dateObj, format)
}

export function reformatTime(timeString: string | nil, format = DISPLAY_TIME_FORMAT): string {
    if(!timeString?.length) return ''
    const timeTuple = parseTime(timeString)
    if(!timeTuple || timeTuple.some(v => v == null)) return ''
    const dateObj = createTime(...timeTuple as [number, number])
    if(!isValid(dateObj)) return ''
    return _formatDate(dateObj, format)
}

export function formatDuration(ms: number): string {
    if (ms < 0) ms = 0; // handle negative durations

    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts: string[] = [];
    if (hours > 0) parts.push(`${hours} hr`);
    if (minutes > 0) parts.push(`${minutes} min`);
    // Always show seconds if no other unit is present
    if (seconds > 0 || parts.length === 0) parts.push(`${seconds} sec`);

    return parts.join(', ');
}
